module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Black.dcd8cc2c.png";